export const startBankOnb = (instance, data) => {
  return instance()
    .post(`/onboarding/api/v1/start/`, data)
    .then((response) => {
      return response;
    });
};

export const submitBankOnb = (instance, data) => {
  return instance()
    .post(`/onboarding/api/v1/submit/`, data)
    .then((response) => {
      return response?.data;
    });
};

export const createV1BuyOrder = (instance, data) => {
  return instance()
    .post(`/fund/api/v1/payment/request/`, data)
    .then((response) => {
      return response?.data;
    });
};
